module.exports = __webpack_public_path__ + "img/666.41a11f02.png";